import { CDN_URL } from '@/config/index.js';

export const giftList = [
  {
    image: `${CDN_URL}/dragonCity/icon_g_1.png`,
    content: ['魔血结晶（中）* 1', '绑定元宝 * 1000'],
  },
  {
    image: `${CDN_URL}/dragonCity/icon_g_2.png`,
    content: ['五彩之灵 * 10', '绑定元宝 * 1000'],
  },
  {
    image: `${CDN_URL}/dragonCity/icon_g_3.png`,
    content: ['防守结晶（中）* 1', '绑定元宝 * 1000'],
  },
  {
    image: `${CDN_URL}/dragonCity/icon_g_4.png`,
    content: ['闯关令（绑定）* 1', '绑定元宝 * 1000'],
  },
  {
    image: `${CDN_URL}/dragonCity/icon_g_5.png`,
    content: ['10倍地图隐藏券 * 1', '绑定元宝 * 1000'],
  },
  {
    image: `${CDN_URL}/dragonCity/icon_g_6.png`,
    content: ['抗反伤药剂 * 1', '绑定元宝 * 1000'],
  },
  {
    image: `${CDN_URL}/dragonCity/icon_g_1.png`,
    content: ['魔血结晶（大）* 1', ''],
  },
  {
    image: `${CDN_URL}/dragonCity/icon_g_7.png`,
    content: ['金莲花 * 30', ''],
  },
];
